import React, { useCallback, useState, useMemo } from 'react';
import { ContainerIconWrapper as Container } from 'src/pages/Investing/Invests/components/styles';
import { Popup } from 'src/interface/cabinet/header/Dropdown/styles';

/** @param {{ active: import('finhelper').GridActiveModel }} props */
const ConvertTradePopup = ({ active }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleMouseOver = useCallback(() => setIsOpen(true), []);
  const handleMouseLeave = useCallback(() => setIsOpen(false), []);

  const tradeWithConvert = useMemo(() => {
    let trade = null;
    active?.buy_trades?.forEach((eachTrade) => {
      if (eachTrade.convert_trade) {
        trade = eachTrade;
      }
    });
    return trade;
  }, [active]);

  if (!tradeWithConvert?.convert_trade?.active?.item) {
    return null;
  }

  const { name, secid } = tradeWithConvert.convert_trade.active.item;

  return (
    <Container onMouseOver={handleMouseOver} onMouseLeave={handleMouseLeave}>
      <img
        style={{
          width: '22px',
          marginTop: '4px',
          marginLeft: '8px',
        }}
        src={require('#app/assets/icons/left-right-arrow.svg')}
        alt=""
      />
      <Popup
        open={isOpen}
        id={'popup-transfer-' + active.id}
        className="asset-popup"
        $position={{ top: '-10px', left: '24px' }}
        width={'300px'}
      >
        <div style={{ padding: '10px 20px', minWidth: 'fit-content' }}>
          Замена на {name} {secid}
        </div>
      </Popup>
    </Container>
  );
};

export default ConvertTradePopup;
